module.exports = __webpack_public_path__ + "static/img/alipay.dcd26aa1.jpeg";